// ranking world list
export default [
  {
    id: 1,
    key: 'bera',
    name: 'Bera',
    filter: 'na',
  },
  {
    id: 19,
    key: 'scania',
    name: 'Scania',
    filter: 'na',
  },
  {
    id: 45,
    key: 'kronos',
    name: 'Kronos',
    filter: 'na',
  },
  {
    id: 70,
    key: 'hyperion',
    name: 'Hyperion',
    filter: 'na',
  },
  {
    id: 30,
    key: 'luna',
    name: 'Luna',
    filter: 'eu',
  },
  {
    id: 46,
    key: 'solis',
    name: 'Solis',
    filter: 'eu',
  },
]

// it contains the legacy world list
export const legacyWorlds = [
  {
    id: 0,
    name: 'Scania',
  },
  {
    id: 1,
    name: 'Bera',
  },
  {
    id: 2,
    name: 'Broa',
  },
  {
    id: 3,
    name: 'Windia',
  },
  {
    id: 4,
    name: 'Khaini',
  },
  {
    id: 5,
    name: 'Bellocan',
  },
  {
    id: 6,
    name: 'Mardia',
  },
  {
    id: 7,
    name: 'Kradia',
  },
  {
    id: 8,
    name: 'Yellonde',
  },
  {
    id: 9,
    name: 'Demethos',
  },
  {
    id: 10,
    name: 'Galicia',
  },
  {
    id: 11,
    name: 'El Nido',
  },
  {
    id: 12,
    name: 'Zenith',
  },
  {
    id: 13,
    name: 'Arcania',
  },
  {
    id: 14,
    name: 'Chaos',
  },
  {
    id: 15,
    name: 'Nova',
  },
  {
    id: 16,
    name: 'Renegades',
  },
  {
    id: 17,
    name: 'Aurora',
  },
  {
    id: 18,
    name: 'Elysium',
  },
  {
    id: 19,
    name: 'Scania',
  },
  {
    id: 30,
    name: 'Luna',
  },
  {
    id: 45,
    name: 'Kronos',
  },
  {
    id: 46,
    name: 'Solis',
  },
  {
    id: 70,
    name: 'Hyperion',
  },
]
